import { useParams } from "react-router-dom";

export function NotImplementedPage() {
  const { name } = useParams<{ name: string }>();
  return (
    <div>
      <h2>{name}</h2>
      <p>This page has not been implemented yet in WebAdminCC.</p>
    </div>
  );
}
